// packages import
import { Box } from '@mui/material'
import { FC } from 'react'
// component import
import { EmptyData } from '../../common/EmptyData'
import DisplayNoteItem from './DisplayNoteItem'
// others
import { DisplayNotesTabProps } from '../../../interfaceTypes'
import { flexCenter } from '../../../theme/styleConstants'

export const DisplayNotesTab: FC<DisplayNotesTabProps> = ({ notes, refetchAllNotes }) => (
  <Box height='185px' sx={{ overflow: 'auto' }}>
    {notes?.length ?
      notes?.map((note, index) => <DisplayNoteItem note={note} key={index} refetchAllNotes={refetchAllNotes} />)
      :
      <Box sx={{ ...flexCenter, height: '100%' }}>
        <EmptyData title='No notes to show' height="712px" iconSize="100px" fontSize="20px" />
      </Box>
    }
  </Box>
)